import {
  AnalyticsFieldName,
  LegalLinksAnalyticsEvent,
} from "@/constants/analytics/Analytics";
import ProcessEnvironment from "@/constants/ProcessEnvironment";
import { LegalLinkTestID } from "@/constants/TestID";
import { useAnalytics } from "@/services/Analytics";
import useAppMonitor from "@/services/AppMonitor";
import { Button } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { openUrl } from "@/utils/navigation.util";

const FooterLinksLayout = {
  spacing: 24,
};

interface LegalFooterLinksProps {
  analyticsSource: string;
}

const LegalFooterLinks = ({ analyticsSource }: LegalFooterLinksProps) => {
  const { track } = useAnalytics();
  const { captureException } = useAppMonitor();
  const trackLinkPressed = (event: string) => {
    track(event, {
      [AnalyticsFieldName.Component]: analyticsSource,
      [AnalyticsFieldName.Source]: analyticsSource,
    });
  };

  const handleTermsOfUse = () => {
    trackLinkPressed(LegalLinksAnalyticsEvent.TermsOfUse);
    void openUrl({
      onError: (error?: Error) => {
        captureException(
          new Error("Failed to open terms of use", { cause: error }),
        );
      },
      url: ProcessEnvironment.EquipTermsOfUse,
    });
  };
  const handlePrivacyPolicy = () => {
    trackLinkPressed(LegalLinksAnalyticsEvent.PrivacyPolicy);
    void openUrl({
      onError: (error?: Error) => {
        captureException(
          new Error("Failed to open privacy policy", { cause: error }),
        );
      },
      url: ProcessEnvironment.EquipPrivacyPolicy,
    });
  };

  return (
    <HStack alignSelf="center" gap={FooterLinksLayout.spacing}>
      <Button
        accessibilityLabel="Terms of use"
        onPress={handleTermsOfUse}
        size="small"
        testID={LegalLinkTestID.TermsOfUse}
        title="Terms of use"
        variant="tertiary"
      />
      <Button
        accessibilityLabel="Privacy policy"
        onPress={handlePrivacyPolicy}
        size="small"
        testID={LegalLinkTestID.PrivacyPolicy}
        title="Privacy policy"
        variant="tertiary"
      />
    </HStack>
  );
};

export { FooterLinksLayout };
export default LegalFooterLinks;
